import { BrowserRouter as Router } from "react-router-dom";
import MainComponent from "./components/MainLayout";
import AuthProvider from "./providers/AuthProvider";

function App() {
  return (
    <Router>
      <AuthProvider>
        <MainComponent />
      </AuthProvider>
    </Router>
  );
}

export default App;
